import { css } from "@emotion/react";

export const Tooltip = css`
  width: 100%;
`;
